import type { Database } from '@popow/infra/types/database.types';
import { createBrowserClient as createBrowserClientSupabase } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';

/**
 * Typed Supabase client for the app database
 */
export type TypedSupabaseClient = SupabaseClient<Database>;

let client: TypedSupabaseClient | undefined;

export function getSupabaseClient(): TypedSupabaseClient {
  if (client) {
    return client;
  }

  client = createBrowserClientSupabase<Database>(
    // biome-ignore lint/style/noNonNullAssertion: SUPABASE config is required
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    // biome-ignore lint/style/noNonNullAssertion: SUPABASE config is required
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );

  return client;
}
